import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './Gallery.module.css';

// Import New Images (img1 to img14)
import img1 from '../../assets/New-Images/img1.JPG';
import img2 from '../../assets/New-Images/img2.JPG';
// import img3 from '../../assets/New-Images/img3.CR2';
import img4 from '../../assets/New-Images/img4.JPG';
import img5 from '../../assets/New-Images/img5.jpg';
import img6 from '../../assets/New-Images/img6.jpg';
import img7 from '../../assets/New-Images/img7.jpg';
import img8 from '../../assets/New-Images/img8.jpg';
import img9 from '../../assets/New-Images/img9.jpg';
import img10 from '../../assets/New-Images/img10.jpg';
import img11 from '../../assets/New-Images/img11.jpg';
import img12 from '../../assets/New-Images/img12.jpg';
import img13 from '../../assets/New-Images/img13.jpg';
import img14 from '../../assets/New-Images/img14.jpg';
import img15 from '../../assets/New-Images/img15.jpg';
import img16 from '../../assets/New-Images/img16.jpg';

// Import WP Images (img1 to img9)
import wpImg1 from '../../assets/wp-images/img1.jpeg';
import wpImg2 from '../../assets/wp-images/img2.jpeg';
import wpImg3 from '../../assets/wp-images/img3.jpeg';
import wpImg4 from '../../assets/wp-images/img4.jpeg';
import wpImg5 from '../../assets/wp-images/img5.jpeg';
import wpImg6 from '../../assets/wp-images/img6.jpeg';
import wpImg7 from '../../assets/wp-images/img7.jpeg';
import wpImg8 from '../../assets/wp-images/img8.jpeg';
import wpImg9 from '../../assets/wp-images/img9.jpeg';


const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const galleryImages = [
    { id: 1, src: img1, title: 'Our Beautiful Farm', category: 'Farm', description: 'Scenic view of Bahariya Farm where nature thrives' },
    { id: 2, src: img2, title: 'Farm Life', category: 'Farm', description: 'Daily activities and peaceful environment' },
    // { id: 3, src: img3, title: 'Natural Landscape', category: 'Farm', description: 'Lush green pastures for our happy cattle' },
    { id: 4, src: img4, title: 'Our Gir Cows', category: 'Cows', description: 'Pure-bred Gir cows, the heart of our dairy' },
    { id: 5, src: img5, title: 'Healthy Livestock', category: 'Cows', description: 'Expert care and natural grazing for our cows' },
    { id: 6, src: img6, title: 'Traditional Process', category: 'Process', description: 'Ancient methods preserved for modern health' },
    { id: 7, src: img7, title: 'Pure Extraction', category: 'Process', description: 'The traditional way of making pure Bilona ghee' },
    { id: 8, src: img8, title: ' Gir Cow Ghee', category: 'Products', description: 'Golden, aromatic, and nutrient-rich Bilona Ghee' },
    { id: 9, src: img9, title: 'Premium Quality', category: 'Products', description: 'Packaged with care to preserve purity' },
    { id: 10, src: img10, title: 'Farm Harvest', category: 'Farm', description: 'Organic farming practices at Bahariya' },
    { id: 11, src: img11, title: 'Sustainable Nature', category: 'Farm', description: 'In harmony with the local ecosystem' },
    { id: 12, src: img12, title: 'Heritage & Tradition', category: 'Process', description: 'Continuing the legacy of pure dairy' },
    { id: 13, src: img13, title: 'The Ghee Process', category: 'Process', description: 'Meticulous steps for the perfect aromatic ghee' },
    { id: 14, src: img14, title: 'Our Pride', category: 'Products', description: 'Final product ready for your healthy kitchen' },
    { id: 15, src: img15, title: 'Our Pride', category: 'Products', description: 'Final product ready for your healthy kitchen' },
    { id: 16, src: img16, title: 'Our Pride', category: 'Products', description: 'Final product ready for your healthy kitchen' },
    { id: 17, src: wpImg1, title: 'Farm Collection', category: 'Farm', description: 'Our serene farm landscape' },
    { id: 18, src: wpImg2, title: 'Process Excellence', category: 'Process', description: 'Maintaining purity in every step' },
    { id: 19, src: wpImg3, title: 'Quality Gir Cows', category: 'Cows', description: 'Indigenous Gir cows at our farm' },
    { id: 20, src: wpImg4, title: 'Pure Bilona Ghee', category: 'Products', description: 'Traditional aromatic bilona ghee' },
    { id: 21, src: wpImg5, title: 'Farm Activities', category: 'Farm', description: 'Morning routines at Bahariya' },
    { id: 22, src: wpImg6, title: 'Traditional Methods', category: 'Process', description: 'Preserving our heritage' },
    { id: 23, src: wpImg7, title: 'Happy Cattle', category: 'Cows', description: 'Healthy environment for cows' },
    { id: 24, src: wpImg8, title: 'Ghee Packaging', category: 'Products', description: 'Ensuring quality until it reaches you' },
    { id: 25, src: wpImg9, title: 'Farm View', category: 'Farm', description: 'Beautiful sunset at Bahariya Farm' },

  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className={styles.gallery}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>Our Gallery</h1>
          <p className="gujarati-text">અમારી ગેલેરી</p>
          <p className={styles.subtitle}>A Glimpse into Our Farm Life & Tradition</p>
        </div>
      </section>

      <section className={`${styles.gallerySection} texture-bg`}>
        <div className="container">
          <div className={styles.intro}>
            <h2>Experience Our Journey</h2>
            <p className="gujarati-text">અમારી યાત્રાનો અનુભવ કરો</p>
            <p className={styles.introText}>
              From our lush green pastures to the golden ghee in your kitchen,
              every step is a testament to our commitment to purity and tradition.
            </p>
          </div>

          <div className={styles.tabsContainer}>
            <button
              className={`${styles.tabButton} ${activeTab === 1 ? styles.active : ''}`}
              onClick={() => setActiveTab(1)}
            >
              Tab 1
            </button>
            <button
              className={`${styles.tabButton} ${activeTab === 2 ? styles.active : ''}`}
              onClick={() => setActiveTab(2)}
            >
              Tab 2
            </button>
            <button
              className={`${styles.tabButton} ${activeTab === 3 ? styles.active : ''}`}
              onClick={() => setActiveTab(3)}
            >
              Tab 3
            </button>
          </div>

          <div className={styles.galleryGrid}>
            {galleryImages.slice((activeTab - 1) * Math.ceil(galleryImages.length / 3), activeTab * Math.ceil(galleryImages.length / 3)).map((image, index) => (
              <motion.div
                key={image.id}
                className={styles.galleryItem}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                onClick={() => openLightbox(image)}
              >
                <div className={styles.imageWrapper}>
                  <img src={image.src} alt={image.title} />
                  <div className={styles.overlay}>
                    <div className={styles.overlayContent}>
                      <span className={styles.category}>{image.category}</span>
                      <h3>{image.title}</h3>
                      <p>{image.description}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className={styles.lightbox} onClick={closeLightbox}>
          <div className={styles.lightboxContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeBtn} onClick={closeLightbox}>×</button>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className={styles.lightboxInfo}>
              <span className={styles.lightboxCategory}>{selectedImage.category}</span>
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;

